/*
Сервис связи компонент с пагинацией
 */

import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";

@Injectable()
export class compToPagination {

  public pageSubject = new Subject<number>();

  public setPage(num: number) {  // Установить страницу
    if (this.pageSubject) {
      this.pageSubject.next(num);
    }
  }

  // Событие изменение страници
  public onChangedPage$(): Observable<number> {
    return this.pageSubject.asObservable();
  }

}
